<style scoped></style>

<template>
    <div>
        <el-menu-item :index="data.url">
            <span :class="{ active_color: data.url === activeIndex }"></span>
            <i :class="iconClass" />
            <span slot="title" :class="{ active: data.url === activeIndex }">
                {{ data.name }}
            </span>
        </el-menu-item>
    </div>
</template>

<script>

export default {
    name: "MenuItem",
    computed: {
        iconClass() {
            return this.data.iconClass;
        }
    },
    data() {
        return {
            activeIndex: ""
        };
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
        alert(1)
        this.activeIndex = this.$route.meta[
            this.$route.meta.length - 1
        ].activeRoute;
        console.log(this.$route);
    },
    watch: {
        $route(val) {
            console.log(this.$route);
            this.activeIndex = val.meta[val.meta.length - 1].activeRoute;
        },
        activeIndex(val) {
            console.log(val);
        }
    }
};
</script>
<style scoped>
.active {
    color: #1890ff;
}

.active_color {
    display: inline-block;
    position: relative;
    left: -10px;
    width: 3px;
    height: 22px;
    background: #1890ff;
}
</style>